import { render, staticRenderFns } from "./SuppliersPage.vue?vue&type=template&id=a90ea04e&scoped=true&"
import script from "./SuppliersPage.vue?vue&type=script&lang=js&"
export * from "./SuppliersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90ea04e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
